module.exports = __webpack_public_path__ + "img/Peritêcio 1.36cceaa6.webp";